import { createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/diamond_gold_rounded.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-d49c1bbe")

_pushScopeId("data-v-d49c1bbe")
const _hoisted_1 = { class: "head bg_gold" }
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  class: "mb-3",
  src: _imports_0
}, null, -1)
const _hoisted_3 = { class: "fev_text5 fw_600" }
const _hoisted_4 = { class: "page_padding bg_white" }
const _hoisted_5 = { class: "fw_700" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_localized_text = _resolveComponent("localized-text")

  return (_openBlock(), _createBlock("div", {
    class: "modal full flex_centered column",
    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('close')))
  }, [
    _createVNode("div", {
      class: "modal_container",
      onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop","prevent"]))
    }, [
      _createVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_localized_text, {
          type: "h3",
          class: "fw_700 text-uppercase",
          localizedKey: "app_FevenPremium",
          text: "Feven Premium"
        }),
        _createVNode("span", _hoisted_3, _toDisplayString(_ctx.localText), 1)
      ]),
      _createVNode("div", _hoisted_4, [
        _createVNode("button", {
          class: "fev_button blue",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.callback()))
        }, [
          _createVNode("span", _hoisted_5, _toDisplayString(_ctx.localActionText), 1)
        ]),
        _createVNode("button", {
          class: "fev_button transparent mt-3",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$opModal.closeLast()))
        }, [
          _createVNode(_component_localized_text, {
            class: "fw_700 text_underlined",
            localizedKey: "app_NonSonoInteressato",
            text: "Non sono interessato"
          })
        ])
      ])
    ])
  ]))
})